document.addEventListener('DOMContentLoaded', () => {

  async function storefrontQuery(query) {

    const response = await fetch(
      `https://${window.bundleStorefront.domain}/api/2025-01/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token':
            window.bundleStorefront.token
        },
        body: JSON.stringify({
          query
        })
      }
    );

    return response.json();

  }

  function formatProduct(product) {

    if (!product.id) {
      return product.text;
    }

    return $(`
      <div style="
        display:flex;
        align-items:center;
        gap:10px;
      ">
        <span>
          ${product.text}
        </span>
      </div>
    `);

  }

  function formatSelection(product) {

    return product.text || '';

  }

  $('.bundle-product-select').each(function () {

    const select = $(this);

    let nextCursor = null;

    select.select2({

      width: '100%',

      placeholder: 'Search fragrance',

      minimumInputLength: 0,

      ajax: {

        delay: 300,

        transport: async function (
          params,
          success,
          failure
        ) {

          try {

            const searchTerm =
              params.data.term || '';

            let query = '';

            // SEARCH MODE
            if (searchTerm.length > 0) {

              query = `
              {
                search(
                  query: "tag:perfume ${searchTerm.replace(/"/g, '\\"')}",
                  types: PRODUCT,
                  first: 50
                ) {

                  edges {

                    node {

                      ... on Product {

                        id

                        title

                        featuredImage {
                          url
                        }

                        metafield(
                          namespace:"custom"
                          key:"fragrance_name"
                        ) {
                          value
                        }

                      }

                    }

                  }

                }

              }
              `;

              const data =
                await storefrontQuery(query);

              const results =
                data.data.search.edges.map(edge => {

                  const product =
                    edge.node;

                  const productText =
                    (
                      product.metafield?.value ||
                      ''
                    ) +
                    ' - ' +
                    product.title;

                  return {

                    id:
                      productText,

                    text:
                      productText,

                    image:
                      product.featuredImage?.url || '',

                    productId:
                      product.id.split('/').pop()

                  };

                });

              success({

                results,

                pagination: {
                  more: false
                }

              });

            }

            // INITIAL LOAD
            else {

              query = `
              {
                collection(
                  handle: "all-fragrances"
                ) {

                  products(
                    first: 50
                    ${
                      nextCursor
                        ? `after: "${nextCursor}"`
                        : ''
                    }
                  ) {

                    pageInfo {

                      hasNextPage

                      endCursor

                    }

                    edges {

                      node {

                        id

                        title

                        featuredImage {
                          url
                        }

                        metafield(
                          namespace:"custom"
                          key:"fragrance_name"
                        ) {
                          value
                        }

                      }

                    }

                  }

                }

              }
              `;

              const data =
                await storefrontQuery(query);

              const products =
                data.data.collection.products;

              nextCursor =
                products.pageInfo.endCursor;

              success({

                results:

                  products.edges.map(edge => {

                    const product =
                      edge.node;

                    const productText =
                      (
                        product.metafield?.value ||
                        ''
                      ) +
                      ' - ' +
                      product.title;

                    return {

                      id:
                        productText,

                      text:
                        productText,

                      image:
                        product.featuredImage?.url || '',

                      productId:
                        product.id
                          .split('/')
                          .pop()

                    };

                  }),

                pagination: {

                  more:
                    products.pageInfo.hasNextPage

                }

              });

            }

          }

          catch(error){

            console.error(error);

            failure(error);

          }

        },

        processResults: function(data){

          return data;

        }

      },

      templateResult:
        formatProduct,

      templateSelection:
        formatSelection,

      escapeMarkup:
        markup => markup

    });

    select.on(
      'select2:select',
      function (e) {

        const selected =
          e.params.data;

        const thumb =
          document.getElementById(
            `thumb-${this.dataset.index}`
          );

        if (
          thumb &&
          selected.image
        ) {

          thumb.src =
            selected.image;

        }

        const hidden =
          this.closest(
            '.bundle-select-wrapper'
          )
          .querySelector(
            '.bundle-product-id'
          );

        if (
          hidden
        ) {

          hidden.value =
            selected.productId;

        }

      }
    );

  });

});

document.addEventListener(
  'submit',
  function (e) {

    const form =
      e.target;

    if (
      form.matches(
        'form[action*="/cart/add"]'
      )
    ) {

      const uidField =
        form.querySelector(
          '.bundle-uid'
        );

      if (
        uidField
      ) {

        uidField.value =
          Date.now() +
          '-' +
          Math.random()
            .toString(36)
            .substring(2, 10);

      }

    }

  },
  true
);